import {css} from '@emotion/react'
import {colors, gethomeLink} from '../../../constants'
import StartpageLogoDark from '../../../images/startpage-logo-dark.svg'
import SocialIcons from '../../SocialIcons'

const Footer = ({languageCode}) => {
    return (
        <footer
            css={css`
                background: ${colors.midnight};
                padding: 57px 2rem;
            `}
        >
            <div
                css={css`
                    max-width: 966px;
                    margin: 0 auto;
                    display: flex;
                    align: center;
                    justify-content: space-between;
                `}
            >
                <a href={gethomeLink(languageCode)} target="__blank">
                    <StartpageLogoDark />
                </a>
                <SocialIcons />
            </div>
        </footer>
    )
}

export default Footer
